// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__ulGah","fullpage":"Layout_fullpage__0WPl-"};